import React from 'react';
import { useState } from 'react';
import './index.css';

export default function Form() {
  const [msgLength, setMsgLength] = useState(0);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [job, setJob] = useState(false);
  const [referrals, setReferrals] = useState(false);
  const [network, setNetwork] = useState(false);
  const [other, setOther] = useState(false);
  const [edu, setEdu] = useState(false);

  function resetForm() {
    setFullName('');
    setMessage('');
    setEmail('');
    setPhone('');
    setJob(false);
    setReferrals(false);
    setNetwork(false);
    setOther(false);
    setEdu(false);
    setMsgLength(0);
    document.querySelector('#message-msg').innerHTML = '';
    document.querySelector('#message-count').innerHTML =  '0 / 200';
    document.getElementById('industry').value = '-Select One-';
  }
  function handleOnSubmit(event) {
    event.preventDefault();

    var errorMessages = '';

    if (fullName.length == 0) {
      errorMessages = errorMessages + 'Name cannot be empty.\n';
    } else if (fullName.indexOf(' ') < 0 && fullName.length != 0) {
      errorMessages = errorMessages + 'Please enter your full name.\n';
    }

    if (email.length == 0 && phone.length == 0) {
      errorMessages += 'You must provide either email or phone.\n';
    } else if (email.indexOf('@') == -1 && email.length != 0) {
      errorMessages += 'Invalid Email!.\n';
    }

    if (message.length > 200) {
      errorMessages =
        errorMessages + 'Message cannot exceed 200 characters. \n';
    } else if(message.length == 0){
      errorMessages = errorMessages + 'Message cannot be empty. \n';
    }

    if (!job && !edu && !other && !referrals && !network) {
      errorMessages += 'Please specify a reason for contact.\n';
    }

    // Displaying errors
    if (errorMessages.length > 0) {
      alert(errorMessages);
    } else {
      alert(
        'Thank you for reaching out! I have received your message and will get back to you as soon as possible.'
      );
    }
  }

  function handleKeyPress() {
    var num = document.querySelector('#message').value.length;
    if (num < 201) {
      setMsgLength(num);
      document.querySelector('#message-count').innerHTML =
        String(num) + ' / 200';
      document.querySelector('#message-msg').innerHTML = '';
    } else {
      setMsgLength(num);
      document.querySelector('#message-msg').innerHTML =
        'Message cannot exceed 200 characters!';
      document.querySelector('#message-count').innerHTML = '';
    }
  }

  function handleOnChange(event) {
    if (event.target.name == 'fullName') {
      setFullName(event.target.value);
    } else if (event.target.name == 'email') {
      setEmail(event.target.value);
    } else if (event.target.name == 'phone') {
      setPhone(event.target.value);
    } else if (event.target.name == 'message') {
      setMessage(event.target.value);
    } else if (event.target.name == 'job') {
      setJob(!job);
    } else if (event.target.name == 'edu') {
      setEdu(!edu);
    } else if (event.target.name == 'referrals') {
      setReferrals(!referrals);
    } else if (event.target.name == 'other') {
      setOther(!other);
    } else if (event.target.name == 'network') {
      setNetwork(!network);
    }
  }

  return (
    <div className="contact">
      <h1>Let's Connect!</h1>
      <form id="signup-form" onSubmit={handleOnSubmit}>
        <div className="separateSection">
          <div className="forminput">
            <label>
              Full Name: <span className="text-danger">*</span>
            </label>
            <input
              onChange={handleOnChange}
              type="text"
              name="fullName"
              placeholder="Your Name"
              id="full-name"
              value={fullName}
            />
          </div>
        </div>

        <div className="separateSection">
          <div className="forminput">
            <label>What's your industry?</label>
            <select id="industry">
              <option>-Select One-</option>
              <option>Software</option>
              <option>IT</option>
              <option>Consulting</option>
              <option>Defense</option>
              <option>Healthcare</option>
              <option>Education</option>
              <option>Research</option>
              <option>Marketing</option>
              <option>HR</option>
              <option>Retail</option>
              <option>Other</option>
            </select>
          </div>
        </div>

        <div className="separateSection">
          <div className="forminput">
            <label>
              Provide One: <span className="text-danger">*</span>
            </label>
          </div>
          <div className="forminput">
            <label>Email:</label>
            <input
              onChange={handleOnChange}
              type="text"
              name="email"
              placeholder="your-email@gmail.com"
              id="email"
              value={email}
            />
          </div>
          <div className="forminput">
            <label>Phone:</label>
            <input
              name="phone"
              onChange={handleOnChange}
              type="text"
              placeholder="(123) 456-7890"
              id="phone"
              value={phone}
            />
          </div>
        </div>

        <div className="separateSection">
          <div className="forminput">
            <label>Message:</label>
            <span className="text-danger">*</span>
            <div onKeyUp={handleKeyPress}>
              <textarea
                id="message"
                tabIndex="1"
                onChange={handleOnChange}
                value={message}
                placeholder={'Your message here...'}
                name="message"
              ></textarea>
              <small id="message-count">
                {msgLength} / 200
              </small>
            </div>
            <small id="message-msg"></small>
          </div>
        </div>

        <div className="separateSection">
          <div className="forminput">
            <label>
              Contact Purpose:
              <span className="text-danger">*</span>
            </label>
          </div>
          <div className="forminput">
            <input
              onChange={handleOnChange}
              type="checkbox"
              className="terms"
              checked={job}
              value="termsAndConditions"
              name="job"
            />
            <label>Job Opportunity</label>
          </div>
          <div className="forminput">
            <input
              onChange={handleOnChange}
              type="checkbox"
              className="terms"
              checked={edu}
              value="termsAndConditions"
              name="edu"
            />
            <label>Educational Opportunity</label>
          </div>
          <div className="forminput">
            <input
              onChange={handleOnChange}
              type="checkbox"
              className="terms"
              checked={network}
              value="termsAndConditions"
              name="network"
            />
            <label>Networking</label>
          </div>
          <div className="forminput">
            <input
              onChange={handleOnChange}
              type="checkbox"
              className="terms"
              checked={referrals}
              value="termsAndConditions"
              name="referrals"
            />
            <label>Referrals</label>
          </div>
          <div className="forminput">
            <input
              onChange={handleOnChange}
              type="checkbox"
              className="terms"
              checked={other}
              value="termsAndConditions"
              name="other"
            />
            <label>Other</label>
          </div>
        </div>
        <div className="separateSection">
          <div className="forminput">
            <button id="submit" type="submit">
              Submit
            </button>
            <button id="clear" type="reset" onClick={resetForm}>
              Clear
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
